import React from "react";
import Logo from "../../assets/images/ehealth.png";
import "./Logo.css";

const logo = () => (
  <div className="Logo">
    <img src={Logo} alt="ehealth-logo" />
  </div>
);

export default logo;
